import { render } from "./IndependentBillingCreatePage.vue?vue&type=template&id=70794b44&ts=true"
import script from "./IndependentBillingCreatePage.vue?vue&type=script&lang=ts"
export * from "./IndependentBillingCreatePage.vue?vue&type=script&lang=ts"

import "./IndependentBillingCreatePage.vue?vue&type=style&index=0&id=70794b44&lang=scss"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__